<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-table>
                    <thead>
                        <tr>
                            <th class="text-left">Date</th>
                            <th class="text-left">User</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="upload in troubleshootingUploads"
                            :key="upload.uploadId"
                            :to="{ name: 'AccountTroubleShootingUploadDetails', params: { accountId, uploadId: upload.uploadId } }"
                        >
                            <td>{{ formatDate(upload.createdAt) }}</td>
                            <td><user-chip :user="upload.user" /></td>
                            <td class="text-right">
                                <v-btn color="warning" :to="{ name: 'AccountTroubleShootingUploadDetails', params: { accountId, uploadId: upload.uploadId } }"
                                    >View Details</v-btn
                                >
                            </td>
                        </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
import { useApi } from '@/api'
import '@/components/VesselDisc.vue'
import { formatDate, handleApiError } from '@/lib/utils'
import { useBreadCrumbsStore } from '@/stores/breadCrumbs'
import type { TroubleshootingUploadSummaryV1 } from '@geckoal/gecko-api-client'
import { onMounted, ref, watch } from 'vue'
import UserChip from '../../components/users/UserChip.vue'

const breadCrumbsStore = useBreadCrumbsStore()

const props = defineProps({
    accountId: {
        type: Number,
        required: true
    }
})

onMounted(() => {
    _loadInfo()
})

watch(
    () => props.accountId,
    () => {
        _loadInfo()
    }
)

const loadingTroubleshootingUploads = ref(false)
const troubleshootingUploads = ref<TroubleshootingUploadSummaryV1[] | undefined>()

const getAccountTroubleshootingUploads = async () => {
    await handleApiError(
        async () => {
            loadingTroubleshootingUploads.value = true
            const response = await useApi().getRecentAccountTroubleshootingUploadsV1({
                accountId: props.accountId
            })
            troubleshootingUploads.value = response.uploads
        },
        async () => {
            loadingTroubleshootingUploads.value = false
        }
    )
}

async function _loadInfo() {
    breadCrumbsStore.$patch({
        items: [
            {
                text: `Account #${props.accountId}`,
                to: {
                    name: 'AccountDetails',
                    params: {
                        accountId: props.accountId
                    }
                }
            },
            {
                text: `Troubleshooting Uploads`
            }
        ]
    })
    await getAccountTroubleshootingUploads()
}
</script>

<style lang="scss" scoped></style>
